module.exports = __webpack_public_path__ + "img/scrm.3f450f7e.png";